import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { getUserChannels } from '../../../api/users';

import { REQUEST } from '../../../constants/request';
import { PERMISSION_NAMES } from '../../../constants/permissionNames';

export const fetchRebuzzChannels = createAsyncThunk(
  'currentUser/fetchRebuzzChannels',
  async (params, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const response = await getUserChannels({
        params: {
          withToken: PERMISSION_NAMES.STREAMITEM_CREATE,
        },
        cancelToken: source.token,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition: (param, { getState }) => {
      const currentLoading =
        getState().currentUser.currentLoadings?.fetchRebuzzChannels ||
        REQUEST.idle;

      return currentLoading !== REQUEST.pending;
    },
  },
);

export const fetchRebuzzChannelsExtraReducers = {
  [fetchRebuzzChannels.pending]: (state, { meta }) => {
    state.currentLoadings.fetchRebuzzChannels = REQUEST.pending;
    state.currentRequestIds.fetchRebuzzChannels = meta.requestId;
  },
  [fetchRebuzzChannels.fulfilled]: (state, { meta, payload }) => {
    if (
      state.currentLoadings.fetchRebuzzChannels === REQUEST.pending &&
      state.currentRequestIds.fetchRebuzzChannels === meta.requestId
    ) {
      state.rebuzzChannels = payload.map(channel => {
        const { orgId, streamId, id: channelId } = channel;
        const channelUID = `${orgId}/${streamId}/${channelId}`;
        return {
          ...channel,
          id: channelUID,
          channelId,
        };
      });
      state.currentLoadings.fetchRebuzzChannels = REQUEST.idle;
      state.currentRequestIds.fetchRebuzzChannels = undefined;
    }
  },
  [fetchRebuzzChannels.rejected]: (state, { error }) => {
    state.currentLoadings.fetchRebuzzChannels = REQUEST.idle;
    state.currentRequestIds.fetchRebuzzChannels = undefined;
    state.currentErrors.fetchRebuzzChannels = error;
  },
};
